<template>
  <div class="profit-loss-reports reports main-content">
    <div class="page-header">
      <h3 class="page-title"> {{ $tc('reports.report', 2) }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="/anchor/dashboard">
            {{ $t('general.home') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="/anchor/reports/sales">
            {{ $tc('reports.report', 2) }}
          </router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div class="col-xs-2">
          <base-button icon="download" size="large" color="theme" @click="onDownload()">
            {{ download_button_txt }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <!-- Tabs -->
        <ul class="tabs">
          <li class="tab">
            <router-link class="tab-link" to="/funder/reports/invoices" @click.native="changeDownloadButtonTxt('Download PDF')">{{ $tc('reports.invoices.invoices', 2) }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/funder/reports/disbursement-report" @click.native="changeDownloadButtonTxt('Download Excel')">{{ $t('reports.disbursement.disbursement_report') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/funder/reports/taxes" @click.native="changeDownloadButtonTxt('Download PDF')">{{ $t('reports.taxes.taxes') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/funder/reports/invoice-report" @click.native="changeDownloadButtonTxt('Download EXcel')">{{ $t('reports.invoice_report.invoice_report') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/funder/reports/approved-finance" @click.native="changeDownloadButtonTxt('Download PDF')">{{ $t('reports.approved_finance.approved_finance') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/funder/reports/payment-outstanding-report" @click.native="changeDownloadButtonTxt('Download Excel')">{{ $t('reports.payment.payment_outstanding_report') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/funder/reports/preapprovedInvoice-report" @click.native="changeDownloadButtonTxt('Download Excel')">{{ $t('reports.preapprovedInvoice_report.invoice_report') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/funder/reports/on-time-payment-report" @click.native="changeDownloadButtonTxt('Download Excel')">{{ $t('reports.ontime_payment.ontime_payment_report') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/funder/reports/profit-share-report" @click.native="changeDownloadButtonTxt('Download Excel')">{{ $t('reports.profit_share.profit_share') }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <transition
      name="fade"
      mode="out-in">
      <router-view ref="report"/>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      download_button_txt : 'Download PDF'
    }
  },
  watch: {
    '$route.path' (newValue) {
      if (newValue === '/funder/reports') {
        this.$router.push('/funder/reports/invoices')
      }
    }
  },
  created () {
    if (this.$route.path === '/funder/reports') {
      this.$router.push('/funder/reports/invoices')
    }
  },
  methods: {
    onDownload () {
      this.$refs.report.downloadReport()
    },
    changeDownloadButtonTxt (txt) {
      this.download_button_txt = txt
    }
  }

}
</script>

<style scoped>
.tab {
  padding: 0 !important;
}

.tab-link {
  padding: 10px 30px;
  display: block
}
</style>
